import { createAction } from '@reduxjs/toolkit'

export const UpdateStore = createAction<Partial<TopHap.StoreState>>('update_store')
